// extracted by mini-css-extract-plugin
module.exports = {"inputFilter":"AffectationTable_inputFilter__3TUtg","scrollContainer":"AffectationTable_scrollContainer__6H5NE","divContainer":"AffectationTable_divContainer__3r2Gd"};